import React, { useState, useEffect, useContext } from 'react';
import {
	Card,
	CardBody,
	Input,
	Table,
	TableCell,
	TableContainer,
	TableHeader,
} from '@windmill/react-ui';
import RazorpayDetailsTable from 'components/razorpayDetails/RazorpayDetailsTable';
import DataWrapper from './DataWrapper';
import NotFound from 'components/table/NotFound';
import PageTitle from 'components/Typography/PageTitle';
import useFilter from 'hooks/useFilter';
import Somethingwentwrong from 'pages/Somethingwentwrong';
import RazorpayDetailsServices from 'services/RazorpayDetailsServices';
import { SidebarContext } from 'context/SidebarContext';
import sidebar from 'routes/sidebar';

const RazorpayDetails = () => {
	const adminInfo = localStorage.getItem('adminInfo')
		? JSON.parse(localStorage.getItem('adminInfo'))
		: null;
	const [loading, setLoading] = useState(false);
	const { isUpdate, setIsUpdate } = useContext(SidebarContext);
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const [tab] = useState(0);
	const [error, setError] = useState(false);
	const [razorpaydetailsData, setRazorpayDetailsData] = useState([]);

	const [status, setStatus] = useState(false);
	const {
		razorpaydetailsRef,
		dataTable,
		serviceData,
		handleSubmitRazorpayDetails,
		currentPage,
	} = useFilter(razorpaydetailsData, itemsPerPage);

	useEffect(() => {
		if (serviceData.length !== 0) {
			setItemsPerPage(serviceData.length);
		}
	}, [serviceData]);

	useEffect(() => {
		const fetchRazorpayDetails = async () => {
			setLoading(true);
			try {
				let response;

				response = await RazorpayDetailsServices.RazorpayDetailsList();

				const updatedData =
					response?.data?.map(
						({
							id,
							entity,
							amount,
							currency,
							status,
							order_id,
							invoice_id,
							international,
							method,
							amount_refunded,
							refund_status,
							captured,
							description,
							card_id,
							bank,
							wallet,
							vpa,
							email,
							contact,
							fee,
							tax,
							created_at,
							...rest
						}) => ({
							id,
							entity,
							amount,
							currency,
							status,
							order_id,
							invoice_id,
							international,
							method,
							amount_refunded,
							refund_status,
							captured,
							description,
							card_id,
							bank,
							wallet,
							vpa,
							email,
							contact,
							fee,
							tax,
							created_at,

							...rest,
						})
					) || [];
				setRazorpayDetailsData(updatedData);
				setStatus(response?.status);
			} catch (error) {
				setError(true);
				console.error('Error fetching razorpaydetails:', error);
				//notifyError("Failed to fetch razorpaydetails. Please try again later.");
			} finally {
				setLoading(false);
			}
		};

		fetchRazorpayDetails();

		setIsUpdate(false);
		// eslint-disable-next-line
	}, [tab, isUpdate]);

	// const hideView = adminInfo?.permission?.some(
	//   (perm) => perm.id_tab === "all order details" && perm.view === 1
	// );
	const isAdmin = adminInfo?.id === 1;

	const hideView = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'all payment details' && perm.view === 1
		  );
	return (
		<>
			{hideView && (
				<>
					<PageTitle sidebar={sidebar().sidebar} />
					<Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
						<CardBody>
							<div style={{ width: '600px' }}>
								<Input
									ref={razorpaydetailsRef}
									className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
									type="search"
									name="search"
									autoComplete="off"
									placeholder="Quick Search"
									onChange={handleSubmitRazorpayDetails}
								/>
							</div>
						</CardBody>
					</Card>
					<DataWrapper loading={loading} error={error} status={status}>
						{serviceData?.length !== 0 ? (
							<TableContainer>
								<div
									className="overflow-y-scroll"
									style={{ maxHeight: '67vh', scrollbarWidth: 'thin' }}
								>
									<Table>
										<TableHeader className="capitalize text-center sticky top-0 z-10 text-sm">
											<tr>
												<TableCell>Sl.No.</TableCell>
												<TableCell>Email</TableCell>
												<TableCell>Payment ID</TableCell>
												<TableCell>Contact</TableCell>
												<TableCell>Order ID</TableCell>
												<TableCell>Entity</TableCell>
												<TableCell>Amount</TableCell>
												<TableCell>Currency</TableCell>
												<TableCell>Status </TableCell>
												<TableCell>Invoice ID</TableCell>
												<TableCell>Method</TableCell>
												<TableCell>amount refunded</TableCell>
												<TableCell>refund status </TableCell>
												<TableCell>captured</TableCell>
												<TableCell> description </TableCell>
												<TableCell>bank </TableCell>
												<TableCell>tax</TableCell>
												<TableCell>Created At</TableCell>
											</tr>
										</TableHeader>
										<RazorpayDetailsTable
											razorpaydetails={dataTable}
											perpage={itemsPerPage}
											currentPage={currentPage}
											tab={tab}
										/>
									</Table>
								</div>
							</TableContainer>
						) : (
							<>
								{status !== true ? (
									<Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
								) : (
									<NotFound title="There are no Razorpay Details." />
								)}
							</>
						)}{' '}
					</DataWrapper>
				</>
			)}
		</>
	);
};

export default RazorpayDetails;
